<!--page starts-->
<section class="page-wrapper">
	<div class="ashton-hero-top fixtures">
		<div class="container">
			<div class="fixtures-top-detail">
				<div class="red-titel">Fixtures & RESULTS</div>
				<!-- <div class="ashton-hero-center-player-tab">
	                <ul>
	                    <li class="courses-name active" id="men"><a routerLink="/fixtures">Men’s Team</a></li>
	                    <li class="courses-name " id="women"><a routerLink="/fixtures-women">Women’s Team</a></li>
	                    <li class="courses-name " id="junior"><a routerLink="/fixtures-junior">Junior’s Team</a></li>
	                </ul>
	            </div> -->
			</div>
		</div>
		<div class="fixtures-top-detail-banner cf">
			<div class="fixtures-top-detail-slider">
				<div class="fixtures-top-detail-slider-box">
					<div class="fixtures-top-detail-slider-box-left">
						<div class="fixtures-top-detail-slider-box-left-text">
							<p>{{first_name}}</p>
						</div>
						<div class="fixtures-top-detail-slider-box-left-image">
							<img [src]="first_image" alt="Bitmap">
						</div>
					</div>
					<div class="fixtures-top-detail-slider-box-center">
						<div class="fixtures-top-detail-slider-box-center-inner">
							<h3 *ngIf="is_home == 'Yes'">Home</h3>
							<h3 *ngIf="is_home == 'No'">Away</h3>
							<p>{{date_time}}</p>
						</div>
					</div>
					<div class="fixtures-top-detail-slider-box-right">
						<div class="fixtures-top-detail-slider-box-left-image">
							<img [src]="second_image" alt="Bitmap">
						</div>
						<div class="fixtures-top-detail-slider-box-left-text">
							<p>{{second_name}}</p>
						</div>
					</div>
				</div>
				<div class="fixtures-top-detail-slider-btn" *ngIf="is_home == 'Yes'">
					<a href="https://ashtonunitedfc.ktckts.com/brand/match-tickets" target="_blank">Buy Tickets</a>
				</div>
				<div class="next-btn-box">
					<a (click)="incrementqty()" *ngIf="next_btn">Next</a>
				</div>
			</div>
		</div>
		<div class="fixtures-center-detail-section cf">
			<div class="container">
				<div class="fixtures-center-detail-tab-section cf">
					<div class="fixtures-center-detail-tab-list">
						<ul>
							<li><a href="#" class="match-name active" id="upcoming-match">Upcoming Matches</a></li>
							<li><a href="#" class="match-name " id="past-match">Past Matches</a></li>
						</ul>
					</div>
					<div class="fixtures-center-detail match-name-content active cf" id="upcoming-match-content">
						<div class="fixtures-center-detail-left">
							<div class="caleandar-box">
								<div class="row text-center">
									<div class="col-md-4">
										<div class="btn-group">
											<div class="btn btn-primary Previous" mwlCalendarPreviousView
												[view]="view" [(viewDate)]="viewDate"> </div>
											<div class="btn btn-outline-secondary" mwlCalendarToday
												[(viewDate)]="viewDate"></div>
											<div class="btn btn-primary next" mwlCalendarNextView
												[view]="view" [(viewDate)]="viewDate"></div>
										</div>
										
									</div>
									<div class="month-name">
										<h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
									</div>
									<div class="calendarmenu">
										
									</div>
								</div>
								<br />
								
								<div *ngIf="events$ | async;  let events">
									<div [ngSwitch]="view">
										<mwl-calendar-month-view *ngSwitchCase="'month'"
											[viewDate]="viewDate" [events]="events"
											[activeDayIsOpen]="activeDayIsOpen"
											(dayClicked)="dayClicked($event.day)"
											(eventClicked)="eventClicked($event.event)">
										</mwl-calendar-month-view>
										<mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate"
											[events]="events" (eventClicked)="eventClicked($event.event)">
										</mwl-calendar-week-view>
										<mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate"
											[events]="events" (eventClicked)="eventClicked($event.event)">
										</mwl-calendar-day-view>
									</div>
								</div>

							</div>
						</div>
						<div class="fixtures-center-detail-right">
							<div class="fixtures-center-detail-right-box cf" *ngFor="let matchs of featurematchestlist">
								<div class="fixtures-center-detail-right-box-top cf">
									<div class="fixtures-center-detail-right-left">
										<div class="fixtures-top-detail-slider-box-left-text">
											<p>{{matchs?.first_name}}</p>
										</div>
										<div class="fixtures-top-detail-slider-box-left-image">
											<img [src]="matchs?.first_image" alt="Bitmap">
										</div>
									</div>
									<div class="fixtures-center-detail-right-center">
										<div class="fixtures-top-detail-slider-box-center-inner">
											<p *ngIf=" matchs?.home_ground == 'Yes'">Home </p>
											<p *ngIf=" matchs?.home_ground == 'No'">Away </p>
											<h2>VS</h2>
										</div>
									</div>
									<div class="fixtures-center-detail-right-right">
										<div class="fixtures-top-detail-slider-box-left-image">
											<img [src]="matchs?.second_image" alt="Bitmap">
										</div>
										<div class="fixtures-top-detail-slider-box-left-text">
											<p>{{matchs?.second_name}}</p>
										</div>
									</div>
								</div>
								<div class="fixtures-center-detail-right-box-bottom cf">
									<div class="fixtures-center-detail-right-box-bottom-left">
										<p>{{matchs?.date_time | amDateFormat: " DD-MM-YYYY  H:mm"}} <span *ngIf="matchs?.home_ground == 'Yes'"> | Home</span>  <span *ngIf="matchs?.team_type == 'Women'"> | Women's Match</span></p>
									</div>
									<div class="fixtures-center-detail-right-box-bottom-btn" *ngIf=" matchs?.home_ground == 'Yes'">
										<a href="https://ashtonunitedfc.ktckts.com/brand/match-tickets" target="_blank">Book Tickets</a>
									</div>
									<span *ngIf="matchs?.team_type == 'Women'" class="free-entry">FREE ENTRY </span>
								</div>
							</div>

						</div>
					</div>
					<div class="fixtures-center-detail match-name-content cf" id="past-match-content">
						<div class="fixtures-center-detail-left">
							<div class="caleandar-box">
								<div class="row text-center">
									<div class="col-md-4">
										<div class="btn-group">
											<div class="btn btn-primary Previous" mwlCalendarPreviousView
												[view]="view" [(viewDate)]="viewDate"> </div>
											<div class="btn btn-outline-secondary" mwlCalendarToday
												[(viewDate)]="viewDate"></div>
											<div class="btn btn-primary next" mwlCalendarNextView
												[view]="view" [(viewDate)]="viewDate"></div>
										</div>
										
									</div>
									<div class="month-name">
										<h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
									</div>
									<div class="calendarmenu">
										<!--  <ul>
											<li class="menu-team-top"><a href="#">men</a>
												<ul class="calendarmenu-team">
													<li><a href="#">Women</a></li>
													<li><a href="#">Junior</a></li>
												</ul>
											</li>
										</ul> -->
										<!-- <select>
											<option value="0">men</option>
											<option value="1">Women</option>
											<option value="2">Junior</option>
										</select> -->
									</div>
								</div>
								<br />
								
								<div *ngIf="eventspast$ | async;  let eventspast">
									<div [ngSwitch]="view">
										<mwl-calendar-month-view *ngSwitchCase="'month'"
											[viewDate]="viewDate" [events]="eventspast"
											[activeDayIsOpen]="activeDayIsOpen"
											(dayClicked)="dayClicked($event.day)"
											(eventClicked)="eventClicked($event.event)">
										</mwl-calendar-month-view>
										<mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate"
											[events]="eventspast" (eventClicked)="eventClicked($event.event)">
										</mwl-calendar-week-view>
										<mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate"
											[events]="eventspast" (eventClicked)="eventClicked($event.event)">
										</mwl-calendar-day-view>
									</div>
								</div>

							</div>
						</div>
						<div class="fixtures-center-detail-right">
							<div class="fixtures-center-detail-right-box cf" *ngFor="let matchs of pastmatchestlist">
								<div class="fixtures-center-detail-right-box-top cf">
									<div class="fixtures-center-detail-right-left">
										<div class="fixtures-top-detail-slider-box-left-text">
											<p>{{matchs?.first_name}}</p>
										</div>
										<div class="fixtures-top-detail-slider-box-left-image">
											<img [src]="matchs?.first_image" alt="Bitmap">
										</div>
									</div>
									<div class="fixtures-center-detail-right-center">
										<div class="fixtures-top-detail-slider-box-center-inner">
											<p *ngIf=" matchs?.home_ground == 'Yes'">Home </p>
											<p *ngIf=" matchs?.home_ground == 'No'">Away </p>
											<h2>{{matchs?.result}}</h2>
										</div>
									</div>
									<div class="fixtures-center-detail-right-right">
										<div class="fixtures-top-detail-slider-box-left-image">
											<img [src]="matchs?.second_image" alt="Bitmap">
										</div>
										<div class="fixtures-top-detail-slider-box-left-text">
											<p>{{matchs?.second_name}}</p>
										</div>
									</div>
								</div>
								<div class="fixtures-center-detail-right-box-bottom cf">
									<div class="fixtures-center-detail-right-box-bottom-left">
										<p>{{matchs?.date_time | amDateFormat: " DD-MM-YYYY  H:mm"}} <span *ngIf="matchs?.home_ground == 'Yes'"> | Home</span>  <span *ngIf="matchs?.team_type == 'Women'"> | Women's Match</span></p>
									</div>
									<div class="fixtures-center-detail-right-box-bottom-right">
										<div class="fixtures-center-detail-right-box-bottom-btn" *ngIf=" matchs?.match_highlight != ''">
											<a href="{{matchs?.match_highlight}}" target="_blank">Match Highlights</a>
										</div>
										<div class="fixtures-center-detail-right-box-bottom-btn" *ngIf=" matchs?.post_match_interview != ''">
											<a href="{{matchs?.post_match_interview}}" target="_blank">Post Match Interview</a>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section><!-- page ends -->